module.exports = __webpack_public_path__ + "img/caselist9.383f52f7.jpg";